<template>
  <v-dialog v-model="value" max-width="800" persistent>
    <v-card>
      <v-form @submit.prevent="onSubmit()" ref="form">
        <v-card-title class="white--text" :class="event == 'delete' ? 'error' : 'green'">
          {{ event == "create" ? $t('action_type.add') : event == "delete" ? $t('action_type.delete') : $t('action_type.edit') }}{{ $t('setting.title') }}
          <template v-if="meter && meter.name"
            >{{ $t('meter.title') }} {{ meter.name }} </template
          >
          <template v-if="area"
            >{{ $t('area.title') }} {{ area.name }}
            <span class="note"
              >({{ area.size | currency }} {{ $t('square_meter') }})</span
          ></template
          >
        </v-card-title>
        <v-card class="scroll-content" elevation="0">
          <v-card-text class="py-5">
            <h2 v-if="event == 'update'" class="mb-5">
              {{
                `
              [${billingSetting.accountingProduct.typeString}]
                          ${billingSetting.accountingProduct.name} @${billingSetting.accountingProduct.unit}
              `
              }}
            </h2>
            <v-autocomplete
              v-if="billingType == 'facility'"
              :items="getAccountingProductFacilityMeter"
              item-text="label"
              :item-value="(r) => r.objectId"
              :label="$t('service')"
              background-color="grey lighten-4"
              flat
              solo
              
              v-model="form.accountingProductId"
              :rules="[rules.required]"
            ></v-autocomplete>
  
            <v-autocomplete
              v-if="billingType == 'service'"
              :items="getAccountingProductService"
              item-text="label"
              :item-value="(r) => r.objectId"
              :label="$t('service')"
              background-color="grey lighten-4"
              flat
              solo
              v-model="form.accountingProductId"
              :rules="[rules.required]"
            ></v-autocomplete>
  
            <v-row
              class="d-flex"
              v-if="
                form.accountingProductId &&
                getAccountingProduct(form.accountingProductId)
              "
            >
              <v-col cols="12">
                <!-- <span>ประเภทบิล</span> -->
                <v-select
                  :items="
                    getAccountingProductBillingType(form.accountingProductId)
                  "
                  v-model="form.type"
                  @input="typeChange"
                  :label="$t('calculation_method')"
                  background-color="grey lighten-4 mb-4"
                  flat
                  solo
                  hide-details
                  :rules="[rules.required]"
                ></v-select>
                <v-divider></v-divider>
              </v-col>
              <template v-if="event != 'delete' && form.type && form.type != 'step' && getAccountingProductBillingType(form.accountingProductId)">
                <template
                  v-if="
                    getAccountingProduct(form.accountingProductId).type !=
                    'discount'
                  "
                >
                  <v-col cols="12">
                    <div class="d-flex justify-space-between">
                      <!-- <span>ราคา{{form.type == "minimum_unit" ||form.type == "minimum_cost"? "ต่อหน่วย": " "}}(฿)</span> -->
                    </div>
                    <div class="box-cost">
                      <div class="inner-cost">
                        <div v-if="form.type == 'minimum_unit' || form.type == 'minimum_cost'">
                          <v-currency-field 
                            :label="`${$t('product.unit_price')}`"
                            v-model="form.cost"
                            :rules="[rules.required3]"
                            background-color="white"
                            outlined
                            hide-details
                          />
                       </div>
                       <div v-else>
                        <v-currency-field 
                          :label="`${$t('market.price')}`"
                          v-model="form.cost"
                          :rules="[rules.required3]"
                          background-color="white"
                          outlined
                          hide-details
                        />
                       </div>
                      </div>
                      <h4>{{ $helper.currencyThEn(tabType) }}</h4>
                    </div>
                 
                    <div class="text-end">
                      <v-btn
                        :loading="isLoadingPrice"
                        text
                        elevation="0"
                        class="blue--text text-decoration-underline px-0"
                        style="height: unset"
                        :disabled="
                          form.areaId == '' ||
                          form.accountingProductId == '' ||
                          billingType != 'service' ||
                          billingSettingType == 'daily'
                        "
                        @click="clickGetPriceAreaAcc()"
                        >{{ $t('bill.pull_price_from_bill') }}
                      </v-btn>
                    </div>
                    <v-divider class="mt-4"></v-divider>
                  </v-col>
                  <div></div>
                  <template v-if="form.type == 'minimum_unit'">
                    <v-col cols="12">
                      <div class="text-end">
                        <!-- <span>ยูนิตขั้นต่ำ (ยูนิต)</span> -->
                        <v-btn
                          text
                          elevation="0"
                          class="blue--text text-decoration-underline cursor-pointer px-0"
                          style="height: unset"
                          @click="solutionCalculateDialog = true"
                          >{{ $t('example_of_calculation') }}</v-btn
                        >
                      </div>
                      <v-currency-field
                        :label="$t('minimum_unit')"
                        v-model="form.minimumUnit"
                        background-color="white"
                        outlined
                        hide-details
                        :rules="[rules.required3]"
                      />
                    </v-col>
                    <v-col cols="12">
                     <div class="d-flex align-center flex-nowrap">
                      <div class="flex-grow-1">
                        <v-currency-field
                          :label="$t('meter.cost_total')"
                          v-model="form.minimumCost"
                          step="1"
                          background-color="white"
                          outlined
                          hide-details
                          :rules="[rules.required2]"
                        />
                      </div>
                      <h4 class="ms-2">{{ $helper.currencyThEn(tabType) }}</h4>
                     </div>
                    </v-col>
                  </template>
                  <template v-if="form.type == 'minimum_cost'">
                    <v-col cols="12">
                      <div class="text-end">
                        <!-- <span>ยูนิตขั้นต่ำ (ยูนิต)</span> -->
                        <v-btn
                          text
                          elevation="0"
                          class="blue--text text-decoration-underline cursor-pointer px-0"
                          style="height: unset"
                          @click="solutionCalculateDialog = true"
                          >{{ $t('example_of_calculation') }}</v-btn
                        >
                      </div>
                      <v-currency-field
                        :label="$t('minimum_unit')"
                        v-model="form.minimumUnit"
                        background-color="white"
                        outlined
                        hide-details
                        :rules="[rules.required3]"
                      />
                    </v-col>
                    <v-col cols="12">
                      <!-- <span>เหมาจ่าย (฿)</span> -->
                       <div class="d-flex align-center flex-nowrap">
                        <div class="flex-grow-1">
                          <v-currency-field
                            :label="$t('meter.all')"
                            v-model="form.minimumCost"
                            background-color="white"
                            outlined
                            hide-details
                            :rules="[rules.required2]"
                          />
                        </div>
                        <h4 class="ms-2">{{ $helper.currencyThEn(tabType) }}</h4>
                       </div>
                    </v-col>
                  </template>
                  <v-col
                    cols="12"
                    v-if="
                      form.type != 'minimum_unit' && form.type != 'minimum_cost'
                    "
                  >
                    <!-- <div class="d-flex justify-space-between">
                      <span>ส่วนลด</span>
                    </div> -->
                    <div class="d-flex align-center flex-nowrap">
                      <v-menu offset-y style="max-width: 600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-currency-field
                          :label="$t('discount')"
                          v-model="form.discount"
                          min="0"
                          background-color="white"
                          outlined
                          :max="form.discountType == 2 ? 100 : ''"
                          :suffix="form.discountType == 2 ? '%' : ''"
                          :rules="
                            form.discountType == 2
                              ? [rules.maxDiscountPercent]
                              : [rules.minDiscountBath]
                          "
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-card>
                        <v-card-title class="px-3 py-2">
                          <h5 class="my-0">{{ $t('product.select_discount_type') }}</h5>
                        </v-card-title>
                        <v-card-text class="px-4 py-0">
                          <v-radio-group  
                            v-model="form.discountType"
                            class="my-0 py-0 small-radio"
                            column
                          >
                            <v-radio :label="$helper.currencyThEn(tabType)" :value="1"></v-radio>
                            <v-radio :label="$t('percent')" :value="2"></v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                      <h4 class="ms-2">{{ $helper.currencyThEn(tabType) }}</h4>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="
                      area &&
                      (form.type == 'monthly_square_metre' ||
                        form.type == 'day_of_month_square_metre')
                    "
                  >
                    <div class="square-metre-data">
                      <div class="head">{{ $t('example_of_calculation') }}</div>
                      <div class="detail">
                        <div>{{ $t('area.stall_name_and_size', { name: area.name, size: area.size | $options.filters.currency }) }}</div>
                        <div>
                          <span class="accounting-product">{{
                            form.accountingProductId
                              ? getAccountingProduct(form.accountingProductId).name
                              : "-"
                          }}</span>
                          <span v-if="form.type == 'monthly_square_metre'"
                            >{{ $t('area.calculate_per_square_meter_per_month') }}
                            {{
                              (costDiscount(form) * area.size) | currency
                            }}({{ $helper.currencySign(tabType) }})</span
                          >
                          <span v-if="form.type == 'day_of_month_square_metre'"
                            >{{ $t('area.calculate_per_square_meter') }}
                            {{
                              (costDiscount(form) * area.size) | currency
                            }}({{ $helper.currencySign(tabType) }})</span
                          >
                        </div>
                        <div v-if="form.type == 'day_of_month_square_metre'">
                          {{ $t('area.multiply_number_of_days_in_month') }}
                          {{ (costDiscount(form) * area.size * 30) | currency }}({{ $helper.currencySign(tabType) }})
                        </div>
                        <div
                          class="warning-setting"
                          v-if="costDiscount(form) * area.size < 0"
                        >
                          {{ $t('validate.setting_is_not_correct_please_edit') }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="form.type == 'day_of_month'">
                    <div class="square-metre-data">
                      <div class="head">{{ $t('example_of_calculation') }}</div>
                      <div class="detail">
                        <div class="mb-2">{{ $t('area.space') }} {{ area ? area.name : '-' }}</div>
                        <div class="mb-2">
                          <span class="accounting-product">{{
                            form.accountingProductId
                              ? getAccountingProduct(form.accountingProductId).name
                              : "-"
                          }}</span>
                          <span
                            >{{ $t('area.multiply_number_of_days_in_month') }}
                            {{ (costDiscount(form) * 30) | currency }}({{ $helper.currencySign(tabType) }})</span
                          >
                        </div>
                        <div class="warning-setting" v-if="costDiscount(form) < 0">
                          {{ $t('validate.setting_is_not_correct_please_edit') }}
                        </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="
                        area &&
                        (form.type == 'daily_square_metre' ||
                          form.type == 'booking_square_metre')
                      "
                    >
                      <div class="square-metre-data">
                        <div class="head">{{ $t('example_of_calculation') }}</div>
                        <div class="detail">
                          <div>
                          {{ $t('area.stall_name_and_size', { name: area.name, size: area.size | $options.filters.currency }) }}
                        </div>
                        <div>
                          <span class="accounting-product">{{
                            form.accountingProductId
                              ? getAccountingProduct(form.accountingProductId).name
                              : "-"
                          }}</span>
                          <span
                            >{{ $t('area.calculate_per_square_meter') }}
                            {{
                              (costDiscount(form) * area.size) | currency
                            }}({{ $helper.currencySign(tabType) }})</span
                          >
                        </div>
                        <div
                          class="warning-setting"
                          v-if="costDiscount(form) * area.size < 0"
                        >
                          {{ $t('validate.setting_is_not_correct_please_edit') }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                </template>
                <v-col cols="12" v-else>
                  <div class="d-flex justify-space-between">
                    <!-- <span>ส่วนลด (฿)</span> -->
                    <v-btn
                      :loading="isLoadingPrice"
                      text
                      elevation="0"
                      class="blue--text text-decoration-underline p-0"
                      style="height: unset"
                      :disabled="
                        form.areaId == '' ||
                        form.accountingProductId == '' ||
                        billingType != 'service' ||
                        billingSettingType == 'daily' ||
                        form.type == 'minimum_unit' ||
                        form.type == 'minimum_cost'
                      "
                      @click="clickGetPriceAreaAcc()">
                        {{ $t('bill.pull_price_from_bill') }}
                    </v-btn
                    >
                  </div>
                  <div class="d-flex align-center flex-nowrap">
                    <v-currency-field
                      :disabled="
                        form.type == 'minimum_unit' || form.type == 'minimum_cost'
                      "
                      :label="$t('discount')"
                      v-model="form.discount"
                      min="0"
                      background-color="white"
                      outlined
                      hide-details
                    />
                    <h3 class="ms-2">{{ $helper.currencyThEn(tabType) }}</h3>
                  </div>
                  <span>*{{ $t('validate.if_not_have_to_set_zero') }}</span>
                </v-col>
              </template>
            </v-row>
  
            <div
              v-if="
                event != 'delete' &&
                billingType == 'facility' &&
                form.type == 'step' &&
                form.accountingProductId &&
                getAccountingProduct(form.accountingProductId)
              "
            >
              <div v-if="form.step && form.step.length > 0">
                <template>
                  <v-simple-table class="list-step-meter">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th width="150px"><h5>{{ $t('default_unit') }}</h5></th>
                          <th width="3%" class="px-0"></th>
                          <th width="140px"><h5>{{ $t('end_unit') }}</h5></th>
                          <th width="140px"><h5>{{ $t('area.method_calculate') }}</h5></th>
                          <th width="140px"><h5>{{ $t('price') }}</h5></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(meterStep, index) in form.step"
                          :key="index"
                        >
                          <template v-if="index != form.step.length - 1">
                            <td class="bg-green">
                              <v-currency-field
                                v-model="meterStep.minUnit"
                                :rules="[index == 0 ? true : rules.minUnit]"
                                placeholder=""
                                outlined
                                dense
                                hide-details
                                :disabled="index == 0 || true"
                              />
                            </td>
                            <td class="bg-green px-0">
                              <h4>{{ $t('to') }}</h4>
                            </td>
                            <td class="bg-green">
                              <v-currency-field
                                v-model="meterStep.maxUnit"
                                placeholder=""
                                outlined
                                dense
                                :rules="[
                                  v => !!v || `${$t('validate.value_must_be_greater_than_or_equal_to')}`, 
                                  v => v >= meterStep.minUnit || `${$t('validate.value_must_be_greater_than_or_equal_to')}`,
                                ]"
                                hide-details
                                step="1"
                                background-color="white"
                                @input="checkInputStep(index)"
                              />
                            </td>
                            <td class="bg-green">
                              <v-select
                                :items="calculateItems"
                                v-model="meterStep.calCulateType"
                                tem-text="text"
                                item-value="value"
                                :placeholder="$t('area.method_calculate')"
                                outlined
                                dense
                                background-color="white"
                                hide-details
                              ></v-select>
                            </td>
                            <td class="bg-green">
                              <v-currency-field
                                v-model="meterStep.cost"
                                background-color="white"
                                placeholder=""
                                outlined
                                dense
                                step="1"
                                hide-details
                                :rules="[rules.minCost]"
                              />
                            </td>
                            <td class="bg-green">
                              <div class="d-flex align-center">
                                <h4 class="mr-2">{{ $helper.currencyThEn(tabType) }}</h4>
                                <v-tooltip top color="bgTooltip">
                                  <template v-slot:activator="{ on, attrs }">
                                    <div
                                      v-bind="attrs"
                                      v-on="on"
                                      style="padding: 0"
                                    >
                                      <v-icon
                                        :color="
                                          checkRowStep(
                                            meterStep,
                                            index == form.step.length - 1
                                          ).isError
                                            ? 'error'
                                            : 'success'
                                        "
                                      >
                                        mdi-information
                                      </v-icon>
                                    </div>
                                  </template>
                                  <div
                                    class="tooltip-box"
                                    v-if="
                                      !checkRowStep(
                                        meterStep,
                                        index == form.step.length - 1
                                      ).isError
                                    "
                                  >
                                    <div>
                                      <b>
                                        {{
                                          checkRowStep(
                                            meterStep,
                                            index == form.step.length - 1
                                          ).textRes
                                        }}
                                      </b>
                                    </div>
                                    <div class="border-dashed"></div>
                                    <div>
                                      <div class="d-flex justify-between">
                                        <div>{{ $t('payment.minimum_water_cost') }}</div>
                                        <div>
                                          <b>
                                            {{
                                              checkRowStep(
                                                meterStep,
                                                index == form.step.length - 1
                                              ).textMinCost
                                            }}
                                          {{ $helper.currencyThEn(tabType) }}
                                          </b>
                                         
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-flex justify-between">
                                      <div>{{ $t('payment.maximum_water_cost') }}</div>
                                      <div>
                                        <b>
                                          {{
                                          checkRowStep(
                                            meterStep,
                                            index == form.step.length - 1
                                          ).textMaxCost
                                          }}
                                          {{ $helper.currencyThEn(tabType) }}
                                        </b>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="tooltip-box" v-else>
                                    <div>{{ $t('validate.please_input_correct_data') }}</div>
                                    <div>
                                      -
                                      {{
                                        checkRowStep(
                                          meterStep,
                                          index == form.step.length - 1
                                        ).textError
                                      }}
                                    </div>
                                  </div>
                                </v-tooltip>
                              </div>
                            </td>
                            <td class="text-center">
                              <div
                                v-if="
                                  index == form.step.length - 2 && index != 0
                                "
                              >
                                <v-icon
                                  class="mr-2"
                                  color="red lighten-1"
                                  @click="delStepMeter()"
                                  >mdi-trash-can-outline</v-icon
                                >
                              </div>
                            </td>
                          </template>
                          <template v-else>
                            <td colspan="7" color="white">
                              <div
                                class="d-flex justify-between align-center mt-5"
                              >
                                <h4 class="m-0" color="secondary">
                                  {{ $t('meter.unit_from_min', { minUnit: meterStep.moreUnit ? meterStep.moreUnit : 0 }) }}
                                </h4>
                                <div class="d-flex align-center">
                                  <div class="max-w-150">
                                    <v-select
                                      v-model="meterStep.calCulateType"
                                      :items="calculateItems"
                                      item-text="text"
                                      item-value="value"
                                      :placeholder="$t('area.method_calculate')"
                                      outlined
                                      dense
                                      hide-details
                                      step="1"
                                    >
                                    </v-select>
                                  </div>
                                  <div class="max-w-150 mx-2">
                                    <v-text-field
                                      v-model="meterStep.cost"
                                      placeholder=""
                                      outlined
                                      dense
                                      hide-details
                                      :rules="[rules.minCost]"
                                      step="1"
                                    >
                                    </v-text-field>
                                  </div>
                                  <div>
                                    <h4>{{ $helper.currencyThEn(tabType) }}</h4>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
              </div>
  
              <div class="px-5 py-3 text-end">
                <v-btn
                  class="px-0"
                  color="primary"
                  elevation="0"
                  text
                  @click="addStepMeter()"
                >
                  <v-icon dark class="me-2">mdi-plus</v-icon>
                  <h4>{{ $t('add_list') }}</h4>
                </v-btn>
              </div>
  
              <v-checkbox
                class="border-checkbox my-2"
                v-model="isMinimumCost"
                flat
                solo
                :label="$t('payment.set_minimum_price')"
                hide-details
              >
              </v-checkbox>
  
              <div v-if="isMinimumCost" class="box-minimum-meter mt-3">
                <v-tooltip top class="me-2" color="bgTooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" style="padding: 0">
                      <div class="text-minimum">
                        <v-icon> mdi-information </v-icon>
                        <div>{{ $t('meter.set_minimum_price_of_meter_calculation') }}</div>
                      </div>
                    </div>
                  </template>
                  <div class="tooltip-box">
                    {{ $t('payment.if_minimum_water_cost_is_not_enough') }}
                    {{ $t('payment.must_pay_water_cost_according_to_minimum_price') }}
                  </div>
                </v-tooltip>
                <div class="d-flex align-center">
                  <div class="max-w-150 me-2">
                    <v-currency-field
                      v-model="form.minimumCost"
                      placeholder=""
                      outlined
                      dense
                      hide-details
                      :rules="[rules.minCost]"
                    />
                  </div>
                  <h4>{{ $helper.currencyThEn(tabType) }}</h4>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            @click="dismiss()"
            :disabled="isLoading">
            {{ $t('close') }}
          </v-btn>
          <template v-if="event != 'delete'">
            <v-btn
              color="success"
              elevation="0"
              type="submit"
              :disabled="isDisableSave">
              {{ $t('save') }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              color="error"
              elevation="0"
              type="submit"
              :disabled="isLoading">
              {{ $t('confirm') }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-dialog v-model="solutionCalculateDialog" max-width="1300">
      <v-card>
        <v-card-title class="flex justify-space-between">
          <div>{{ $t('example_of_calculation') }}</div>
          <v-btn icon color="error" @click="solutionCalculateDialog = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <img
            src="../assets/images/e4.jpg"
            alt="e4"
            v-if="form.type == 'minimum_unit' && meterType == 'elec'"
          />
          <img
            src="../assets/images/w4.jpg"
            alt="w4"
            v-else-if="form.type == 'minimum_unit' && meterType == 'water'"
          />
          <img
            src="../assets/images/e6.jpg"
            alt="e6"
            v-else-if="form.type == 'minimum_cost' && meterType == 'elec'"
          />
          <img
            src="../assets/images/w6.jpg"
            alt="w6"
            v-else-if="form.type == 'minimum_cost' && meterType == 'water'"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: Boolean,
    area: Object,
    billingSetting: Object,
    event: String,
    billingType: String,
    meterType: String,
    meter: Object,
    isLoading: Boolean,
    billingSettingType: String,
    closeDialogConfirm: {
      type: Boolean,
      default: false,
    },
    tabType: {
      type: String,
      default() {
        return this.$globalCurrencyCode;
      }
    }
  },
  computed: {
    getAccountingProductsWithLabel() {
      return this.$store.getters[
        "accountingProducts/getAccountingProductsWithLabel"
      ](this.billingSettingType);
    },

    getAccountingProductService() {
      return this.$store.getters[
        "accountingProducts/getAccountingProductService"
      ](this.billingSettingType);
    },
    getAccountingProductFacility() {
      return this.$store.getters[
        "accountingProducts/getAccountingProductFacility"
      ](this.billingSettingType);
    },
    ...mapGetters({
      getAreas: "markets/getAreas",
      projectId: "markets/getProjectId",
      meterSettings: "meter/getMeterSettings",
      areaAccountingProduct: "areaAccountingProduct/areaAccountingProduct",
    }),
    getAccountingProductFacilityMeter() {
      return this.getAccountingProductFacility.filter(
        (i) => i.subType == this.meterType
      );
    },
    isDisableSave() {
      if (this.isLoading && !this.form.type) {
        return true
      } else if (this.getAccountingProduct(this.form?.accountingProductId)?.type == "discount") {
        if (!(this.form.discount || this.form.discount === 0)) return true
      } else if (this.form.type != 'step') {
        if (!(this.form.cost || this.form.cost === 0)) return true
        if ((this.form.discountType == 1 && this.form.discount > this.form.cost) || 
            (this.form.discountType == 2 && this.form.discount > 100)) {
          return true
        }
      }
    }
  },
  watch: {
    value(data) {
      if (data) {
        this.$nextTick(() => {
          this.initData();
        });
      }
    }
  },
  data() {
    return {
      solutionCalculateDialog: false,
      form: {
        areaId: "",
        accountingProductId: "",
        cost: "",
        minimumUnit: "",
        minimumCost: "",
        type: "",
        meterId: "",
        discountType: 1,
        discount: "",
        originalDiscount: 0,
        step: [],
      },
      isMinimumCost: false,
      tempCalCulateType: "unit",
      tempCost: 0,
      calculateItems: [
        { value: "unit", text: this.$t('meter.unit_per_unit') },
        { value: "all", text: this.$t('meter.all') },
      ],
      isLoadingPrice: false,
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
        required2: (value) => value >= 0 || this.$t('validate.amount_must_be_greater_than_or_equal_to_zero'),
        required3: (value) => value >= 0 || this.$t('validate.amount_must_be_positive'),
        minUnit: (v) => v > 0 || this.$t('validate.please_input_greater'),
        maxUnit: (v) => this.$t('validate.please_more_or_equal_days'),
        minCost: (v) => v > 0 || `${this.$t('validate.please_min_cost', { currencySign: this.$helper.currencySign(this.tabType) })}`,
        maxDiscountPercent: (v) =>  v >= 0 && v <= 100  || this.$t('validate.please_max_percent'),
        minDiscountBath: (v) =>  v >= 0 || this.$t('validate.please_min_cost', { currencySign: '' }),
      },
    };
  },
  methods: {
    initData() {
      this.$refs.form.resetValidation();
      if (this.event == "update") {
        this.form = {
          id: this.billingSetting.objectId,
          accountingProductId: this.billingSetting.accountingProduct.objectId,
          type: this.billingSetting.type,
          cost: this.billingSetting.type == 'step' ? 0 : this.billingSetting.cost,
          minimumUnit: this.billingSetting.minimumUnit,
          minimumCost: this.billingSetting.minimumCost,
          areaId: this.billingSetting.area.objectId,
          billingSettingId: this.billingSetting.objectId,
          discountType: this.billingSetting.discountType || 1,
          discount: this.billingSetting.type == 'step' ? 0 : this.billingSetting.discount,
          originalDiscount: this.billingSetting.originalDiscount,
          step: this.billingSetting.step,
        };
        if(parseFloat(this.billingSetting.minimumCost) > 0 && this.billingSetting.minimumCost) {
          this.isMinimumCost = true;
        }else{
          this.isMinimumCost = false;
        }
        if (!this.form.step)
          this.form.step = [
            {
              minUnit: 0,
              maxUnit: null,
              moreUnit: 0,
              cost: 0,
              calCulateType: "unit",
            },
            {
              minUnit: 0,
              maxUnit: null,
              moreUnit: 0,
              cost: 0,
              calCulateType: "unit",
            },
          ];
      } else {
        this.form = {
          areaId: "",
          accountingProductId: "",
          cost: "",
          minimumUnit: "",
          minimumCost: "",
          type: "",
          meterId: "",
          discountType: 1,
          discount: "",
          originalDiscount: 0,
          step: [
            {
              minUnit: 0,
              maxUnit: null,
              moreUnit: 0,
              cost: 0,
              calCulateType: "unit",
            },
            {
              minUnit: 0,
              maxUnit: null,
              moreUnit: 0,
              cost: 0,
              calCulateType: "unit",
            },
          ],
        };
        this.isMinimumCost = false;
        if (this.area) this.form.areaId = this.area.objectId;
        if (this.meter) this.form.meterId = this.meter.objectId;
      }
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        if (this.event == "create") {
          this.onSave();
        }
        else if (this.event == "delete") {
          this.onDelete();
        } else {
          this.onSaveUpdate();
        }
      }
    },
    onSave() {
      this.form.cost = this.form.cost ? Number(this.form.cost) : 0;
      this.form.minimumUnit = this.form.minimumUnit
        ? Number(this.form.minimumUnit)
        : 0;
      this.form.minimumCost = this.form.minimumCost
        ? Number(this.form.minimumCost)
        : 0;
      this.form.discount = this.form.discount ? Number(this.form.discount) : 0;
      if (
        this.getAccountingProduct(this.form.accountingProductId).type ==
        "discount"
      ) {
        this.form.discount = this.form.discount
          ? Number(this.form.discount)
          : 0;
        this.form.cost = 0;
        this.form.discountType = 1;
      } else {
        this.form.cost = this.form.cost ? Number(this.form.cost) : 0;
      }
      if (this.form.discountType == 1) {
        this.form.originalDiscount = this.form.discount;
      } else {
        this.form.originalDiscount = this.$helper.round(
          (this.form.cost * this.form.discount) / 100
        );
      }
      this.$emit("onSave", this.form);
    },
    onSaveUpdate() {
      this.form.cost = this.form.cost ? Number(this.form.cost) : 0;
      this.form.minimumUnit = this.form.minimumUnit
        ? Number(this.form.minimumUnit)
        : 0;
      this.form.minimumCost = this.form.minimumCost
        ? Number(this.form.minimumCost)
        : 0;
      this.form.discount = this.form.discount ? Number(this.form.discount) : 0;
      if (
        this.getAccountingProduct(this.form.accountingProductId).type ==
        "discount"
      ) {
        this.form.discount = this.form.discount
          ? Number(this.form.discount)
          : 0;
        this.form.cost = 0;
        this.form.discountType = 1;
      } else {
        this.form.cost = this.form.cost ? Number(this.form.cost) : 0;
      }
      if (this.form.discountType == 1) {
        this.form.originalDiscount = this.form.discount;
      } else {
        this.form.originalDiscount = this.$helper.round(
          (this.form.cost * this.form.discount) / 100
        );
      }
      this.$emit("onSaveUpdate", this.form);
    },
    onDelete() {
      this.$emit("onDelete", this.form);
    },
    getAccountingProduct(id) {
      const ac = this.getAccountingProductsWithLabel?.find(
        (i) => i.objectId === id
      );
      return ac;
    },
    getAccountingProductBillingType(id) {
      const ac = this.getAccountingProductsWithLabel?.find(
        (i) => i.objectId === id
      );
      return ac?.returnListSelect;
    },
    async clickGetPriceAreaAcc() {
      this.isLoadingPrice = true;
      await this.$store.dispatch(
        "areaAccountingProduct/getAreaAccountingProductPrice",
        { ...this.form, marketId: this.area.market.objectId, currencyCode: this.tabType }
      );
      if (this.areaAccountingProduct) {
        if (
          this.getAccountingProduct(this.form.accountingProductId).type ==
          "discount"
        ) {
          this.form.discount = this.areaAccountingProduct.discount || 0;
          this.$toast.show({
            content: `${this.$t('bill.pull_discount_from_bill_success')} ${this.$t('discount')} 
            ${this.areaAccountingProduct.discount || 0} ${this.$helper.currencyThEn(this.tabType)}`,
            color: "success",
          });
        } else {
          this.form.cost = this.areaAccountingProduct.cost || 0;
          this.$toast.show({
            content: `${this.$t('bill.pull_price_from_bill_success')} ${this.$t('price')} 
            ${this.areaAccountingProduct.cost || 0} ${this.$helper.currencyThEn(this.tabType)}`,
            color: "success",
          });
        }
      } else {
        this.$toast.show({
          content: `${this.$t('bill.bill_service_price_not_set')}`,
          color: "error",
        });
      }
      this.isLoadingPrice = false;
    },
    typeChange(value) {
      if (value == "minimum_unit" || value == "minimum_cost") {
        this.form.discount = 0;
      }else if(value == 'step'){
        this.form.discount = 0;
        this.form.cost = 0;
      }
    },
    costDiscount(form) {
      if (!form.discount || form.discount == 0) return form.cost;
      else
        return form.discountType == 1
          ? form.cost - form.discount
          : form.cost - (form.cost * form.discount) / 100;
    },
    addStepMeter() {
      if (this.form) {
        if (this.form.step && this.form.step.length >= 2) {
          let meterStepLength = this.form.step.length;
          let bfmeterStep = this.form.step[meterStepLength - 2];
          let lastmeterStep = this.form.step[meterStepLength - 1];

          if(bfmeterStep) {
            lastmeterStep.minUnit = bfmeterStep.maxUnit ? parseFloat(bfmeterStep.maxUnit) + 1 : parseFloat(bfmeterStep.minUnit) + 1
          }
          lastmeterStep.maxUnit = bfmeterStep
            ? parseFloat(bfmeterStep.maxUnit) + 1
            : 0;
          this.form.step.push({
            minUnit: 1,
            maxUnit: null,
            moreUnit: bfmeterStep.maxUnit ? parseFloat(bfmeterStep.maxUnit) + 2 : bfmeterStep.minUnit + 2,
            cost: this.tempCost ? this.tempCost : 0,
            calCulateType: this.tempCalCulateType
              ? this.tempCalCulateType
              : "unit",
          });
        } else {
          this.form.step = [
            {
              minUnit: 0,
              maxUnit: null,
              moreUnit: 0,
              cost: this.tempCost ? this.tempCost : 0,
              calCulateType: this.tempCalCulateType
                ? this.tempCalCulateType
                : "unit",
            },
            {
              minUnit: 0,
              maxUnit: null,
              moreUnit: 0,
              cost: this.tempCost ? this.tempCost : 0,
              calCulateType: this.tempCalCulateType
                ? this.tempCalCulateType
                : "unit",
            },
          ];
        }
      }
    },
    delStepMeter(index = -1) {
      let indexSplce = index > -1 ? index : this.form.step.length - 1;
      if (this.form) {
        if (this.form.step && this.form.step.length > 2) {
          this.form.step.splice(indexSplce, 1);
        }
      }
    },
    checkInputStep(index) {
      if (
        index >= 0 &&
        this.form.step &&
        this.form.step.length >= 2
      ) {
        for (const idx in this.form.step) {
          if (idx > index) {
            let bfmeter = this.form.step[idx - 1];
            let meter = this.form.step[idx];
            if (meter && bfmeter) {
              meter.minUnit = parseFloat(bfmeter.maxUnit ? bfmeter.maxUnit : bfmeter.minUnit) + 1;
              if (parseFloat(meter.maxUnit) < parseFloat(meter.minUnit)) {
                meter.maxUnit = meter.minUnit;
              }
              meter.moreUnit = meter.minUnit;
            }
          }
        }
      }
    },
    checkRowStep(meterStep) {
      let res = {
        isError: false,
        textError: "",
        textRes: "",
        textMinCost: "",
        textMaxCost: "",
      };
      if (meterStep) {
        if (
          parseFloat(meterStep.cost) > 0 &&
          parseFloat(meterStep.maxUnit) > 0
        ) {
          res.textRes = `${this.$t('meter.meter_unit_from')} 
          ${this.$helper.toCurrency(meterStep.minUnit)} - 
          ${this.$helper.toCurrency(meterStep.maxUnit)} ${meterStep.calCulateType == 'all' ? this.$t('meter.all') : this.$t('meter.per_unit')} 
          ${this.$helper.toCurrency(meterStep.cost, this.tabType, {isSuffixText: true, isThEn: true})}`;
          res.textMinCost = `${this.$helper.toCurrency(
            parseFloat(meterStep.minUnit) * parseFloat(meterStep.cost)
          )}`;
          res.textMaxCost = `${this.$helper.toCurrency(
            parseFloat(meterStep.maxUnit) * parseFloat(meterStep.cost)
          )}`;
        } else {
          res.isError = true;
          res.textError = `${this.$t('validate.please_input_end_unit_and_price_correct')}`;
        }
      }
      return res;
    },
    dismiss() {
      if(this.closeDialogConfirm) {
        this.$emit("onCloseDialog");
      }else{
        this.$emit("input", false);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
}

.note {
  font-size: 15px;
  margin-left: 10px;
}

.square-metre-data {
  color: gray;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #E9F5EA;
  border: 1px solid #4CAF50;
  border-radius: 5px;
  padding: 10px 10px 10px 20px;
  .head {
    font-weight: 500;
    color: #4CAF50;
    font-size: 16px;
  }
  .detail{
    text-align: right;
    font-size: 18px;
  }

  .accounting-product {
    font-weight: 500;
    margin-right: 2px;
  }

  .warning-setting {
    color: var(--v-error-base);
  }
}
.max-w-150 {
  max-width: 150px;
}

.box-minimum-meter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .text-minimum {
    display: flex;
    align-items: center;
    color: #d47301;
    background-color: #f7e1c7;
    border-radius: 10px;
    padding: 10px;
    i {
      color: #d47301 !important;
    }
  }
}

.border-checkbox {
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #4caf50;
}

.border-dashed{
  border: 1px dashed #fff !important;
  margin: 8px 0 !important;
}

.bg-green {
  background-color: #e9f5ea;
}

.box-cost{
  background-color: #E9F5EA;
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px 12px;
  border-radius: 5;
  .inner-cost{
    flex: 1;
  }
}

.bg-white{
  background-color: #ffffff;
}

.list-step-meter{
  tbody {
    tr:hover {
      background-color: white !important;
    }
  }
}

.scroll-content{
  max-height: 550px;
  overflow-y: auto;
}

</style>
<style>
.small-radio label {
  font-size: 14px;
}
</style>
